<div *ngIf="!isWizard">
  <div class="sub-header">{{'onboarding.select_location ' | translate}}</div>

  <div class="row margin-top-8">
    <div class="col-md-4 label">
      {{'onboarding.select_location' | translate}}:
      <span class="help fa hubtiger-tooltip" pTooltip="{{'onboarding.select_shop_info' | translate}}"></span>
    </div>
    <div class="col-md-8">
      <div class="p-inputgroup">
        <span class="p-inputgroup-addon"><i class="fa fa-home"></i></span>
        <p-dropdown [options]="locations" [(ngModel)]="config.LocationID"
                    placeholder="{{'onboarding.select_shop' | translate}}">
        </p-dropdown>
      </div>
    </div>
  </div>

  <div class="row margin-top-8">
    <div class="col-md-4 label">
      {{'onboarding.select_payment_type' | translate}}:
    </div>
    <div class="col-md-8">
      <div class="ui-inputgroup">
        <span class="ui-inputgroup-addon"><i class="fa fa-home"></i></span>
        <p-dropdown [options]="paymentTypes" [(ngModel)]="config.PaymentMethodID">
        </p-dropdown>
      </div>
    </div>
  </div>


  <div class="row margin-top-8">
    <div class="col-md-8 label"></div>
    <div class="col-md-4">
      <button type="submit" class="iso-round-button" style="float: right;"
              (click)="updateConfig()"
              [disabled]="busy || !config.LocationID">{{ busy ? ('onboarding.button.please_wait' | translate) : (config.LocationID) ? ('onboarding.button.update_config' | translate) : ('onboarding.button.set_config' | translate)}}</button>
    </div>
  </div>

  <div class="row margin-top-8">
    <div class="col-md-12 label">
      <br/>
      <br/>
      To enable the products for the web or integration, you can do this either individually, or on a bulk basis,
      using either of the following methods:
      <br/>
      <br/>
      <h5>Individual</h5>
      <ul>
        <li>Open the product for editing within Retail Express</li>
        <li>From the main tab, locate the Web Service section</li>
        <li>Tick the Export to Web Service option</li>
        <li>Highlight the appropriate Sales Channel in the left box</li>
        <li>Highlight the appropriate Source Group from the right box</li>
        <li>Click Update</li>
      </ul>
      <img src="./../../../../../../assets/pos/re-individual.png"/>

      <br/>
      <br/>
      <br/>
      <h5>Bulk Products</h5>
      <ul>
        <li>Navigate to: <strong>Inventory > Mass Download</strong></li>
        <li>Follow the prompts to <strong>download the spreadsheet</strong> of the products within the database
        </li>
        <li>For each product that you want to export, in the column <strong>ExportToWebService</strong> change
          the option to <strong>True</strong></li>
        <li>Each Sales Channel has it’s own column; to select the appropriate Sales Channel and Source Group
          <strong>enter the name of the Source Group</strong> in the appropriate column.
        </li>
        <li><strong>Save</strong> the spreadsheet</li>
        <li><strong>Upload</strong> the file through the <strong>Inventory > Mass Upload</strong> method (ensure
          you have unticked the options "Update the Supplier SKU using the Product Id" and "Update
          Inventory").
        </li>
      </ul>
      <img src="./../../../../../../assets/pos/re-bulk.png"/>


    </div>
  </div>
</div>

<!--Bit of a stuff up because of the dark UI in the wizard and light wizard in the portal, this is a shared compnent :(-->
<div *ngIf="isWizard">
  <div class="row margin-top-32 help-row">
    <div class="col-md-12">
      <div class="p-float-label">
        <p-dropdown [options]="locations" [(ngModel)]="config.LocationID"
                    placeholder="{{'onboarding.select_shop' | translate}}">
        </p-dropdown>
        <label>{{'onboarding.select_location' | translate}}</label>
      </div>
    </div>
    <span class="help fa hubtiger-tooltip" pTooltip="{{'onboarding.select_shop_info' | translate}}"></span>
  </div>

  <div class="row margin-top-32">
    <div class="col-md-12">
      <button type="submit" class="iso-round-button" style="float: right;"
              (click)="updateConfig()"
              [disabled]="busy || !config.LocationID">{{ busy ? ('onboarding.button.please_wait' | translate) : (config.LocationID) ? ('onboarding.button.update_config' | translate) : ('onboarding.button.set_config' | translate)}}</button>
    </div>
  </div>
</div>


<p-toast position="bottom-right" styleClass="hubtiger-toast"></p-toast>
